var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":{ name: 'authSignUp.sign_up' }}},[_vm._v(" Farmer Sign Up ")])],1),_c('div',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":{ name: 'auth.e_registration' }}},[_vm._v(" WareHouseUser Sign Up ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }